module.exports = __webpack_public_path__ + "static/media/iconSearch.e2bb7fd4.svg";